import { Shift } from "@src/lib/interface";
import { ReactElement } from "react";

interface NfcInstructionsProps {
  shift: Shift;
}

export function NfcInstructionsDesc({ shift }: NfcInstructionsProps): ReactElement {
  if (!shift.nfcTagRequests?.length) {
    return (
      <p>
        When you clock in, you'll need to tap your mobile device against the Clipboard tag. The tag
        should be on a Clipboard Health poster near the facility's sign-in desk. If you experience
        any issues, please visit this{" "}
        <a
          href="https://support.clipboardhealth.com/hc/en-us/articles/7963141818391"
          target="_blank"
          rel="noreferrer"
        >
          page
        </a>
        .
      </p>
    );
  }
  if (shift.nfcTagRequests.length >= 2) {
    return (
      <>
        <p>
          When you clock in, you'll need to tap your mobile device against the Clipboard tag. The
          Clipboard tags are placed at the following locations:
        </p>
        <ul className="nfc-tags-padding">
          {shift.nfcTagRequests.map((tag, index) => {
            return (
              <li key={tag.tagLocation}>
                Tag {index + 1} is located at {tag.tagLocation}
              </li>
            );
          })}
        </ul>
        <p>
          If you experience any issues, please visit this{" "}
          <a
            href="https://support.clipboardhealth.com/hc/en-us/articles/7963141818391"
            target="_blank"
            rel="noreferrer"
          >
            page
          </a>
        </p>
      </>
    );
  }
  return (
    <p>
      When you clock in, you'll need to tap your mobile device against the Clipboard tag. The
      Clipboard tag is placed at{" "}
      {shift.nfcTagRequests?.length && shift.nfcTagRequests[0].tagLocation}. If you experience any
      issues, please visit this{" "}
      <a
        href="https://support.clipboardhealth.com/hc/en-us/articles/7963141818391"
        target="_blank"
        rel="noreferrer"
      >
        page
      </a>
    </p>
  );
}
